import { Component, type ReactNode } from 'react'

/** Keep the workspace shell alive when a lazy route's deployed chunk is unavailable. */
export class RouteErrorBoundary extends Component<{
  children: ReactNode
  fallback: ReactNode
  onError: () => void
}, { failed: boolean }> {
  state = { failed: false }
  static getDerivedStateFromError() { return { failed: true } }
  componentDidCatch() { this.props.onError() }
  render() { return this.state.failed ? this.props.fallback : this.props.children }
}
